import {
  Alert,
  Checkbox,
  CircularProgress,
  FormControl,
  FormControlLabel,
  FormGroup,
  FormLabel,
  Grid,
} from '@mui/material';
import { makeStyles } from '@mui/styles';
import React, { useState, useEffect } from 'react';
import ReactMarkdown from 'react-markdown';
import { useMount, useUpdateEffect } from 'react-use';
import { TERMS_LIST } from '../../common/consts';
import { termsGetData } from '../../common/util';

const getChekcControl = ({ name, color, value, onChange }) => (
  <Checkbox {...{ name, color, value, checked: value, onChange }} />
);

const useStyles = makeStyles((theme) => ({
  [theme.breakpoints.up('md')]: {
    markDownGrid: {
      height: '320px',
    },
    progressWrap: {
      height: '320px',
    },
  },
  [theme.breakpoints.between('sm', 'md')]: {
    markDownGrid: {
      height: '200px',
    },
    progressWrap: {
      height: '200px',
    },
  },
  [theme.breakpoints.down('sm')]: {
    markDownGrid: {
      height: '160px',
    },
    progressWrap: {
      height: '160px',
    },
  },
  markDownGrid: {
    minHeight: '20%',
    overflowY: 'scroll',
    fontSize: '.7rem',
    border: `1px solid ${theme.palette.text.primary}`,
    padding: '4px 10px',
    opacity: 0.5,
  },
  progressWrap: {
    minHeight: '20%',
    justifyContent: 'center',
    display: 'flex',
    alignItems: 'center',
  },
}));

const SignupTermsContainer = ({ setEnabled }) => {
  const classes = useStyles();
  const [terms, setTerms] = useState([]);
  const [pending, setPending] = useState(true);
  const [error, setError] = useState('');
  const [checkTerms, setCheckTerms] = useState({
    all: false,
    service: false,
    privacy: false,
    location: false,
  });
  const { service, privacy, location } = checkTerms;

  useUpdateEffect(() => {
    if (!service && !privacy)
      setError('이용약관과 개인정보 수집 및 이용은 필수 동의 사항입니다.');
    else if (!service) setError('이용약관은 필수 동의 사항입니다.');
    else if (!privacy)
      setError('개인정보 수집 및 이용은 필수 동의 사항입니다.');
    else setError('');
  }, [checkTerms]);

  useUpdateEffect(() => {
    setEnabled(error.length === 0);
  }, [error]);

  useEffect(() => {
    if (service && privacy && location)
      setCheckTerms((prevCheck) => ({ ...prevCheck, all: true }));
    else setCheckTerms((prevCheck) => ({ ...prevCheck, all: false }));
  }, [service, privacy, location, setCheckTerms]);

  useMount(async () => {
    const termsArr = await termsGetData();
    setTerms([...termsArr]);
    setPending(false);
  });

  const onChange = (e) => {
    if (e.target.name === 'all') {
      if (checkTerms[e.target.name] === false)
        setCheckTerms({
          all: true,
          service: true,
          privacy: true,
          location: true,
        });
      else
        setCheckTerms({
          all: false,
          service: false,
          privacy: false,
          location: false,
        });
    } else
      setCheckTerms({
        ...checkTerms,
        [e.target.name]: !checkTerms[e.target.name],
      });
  };

  return (
    <Grid container spacing={2} sx={{ padding: 2, height: 'inherit' }}>
      <Grid item xs={12}>
        <FormGroup>
          <FormControlLabel
            control={getChekcControl({
              name: 'all',
              color: 'secondary',
              required: false,
              value: checkTerms.all,
              onChange,
            })}
            label="이용약관, 개인정보 수집 및 이용, 위치정보 이용약관(선택)에 모두 동의합니다."
            sx={{ '& .MuiFormControlLabel-label': { fontSize: 15 } }}
          />
        </FormGroup>
      </Grid>
      {pending && (
        <Grid item xs={12} className={classes.progressWrap}>
          <CircularProgress color="secondary" />
        </Grid>
      )}
      {!pending &&
        TERMS_LIST.map(({ name, label, required }, i) => (
          <Grid container item xs={12} md={4} key={name}>
            <Grid item>
              <FormControl
                required={required}
                component="fieldset"
                variant="standard"
              >
                <FormGroup sx={{ flexDirection: 'row', alignItems: 'center' }}>
                  {getChekcControl({
                    name,
                    color: 'secondary',
                    value: checkTerms[name],
                    onChange,
                  })}
                  <FormLabel>{label}</FormLabel>
                </FormGroup>
              </FormControl>
            </Grid>
            <Grid item className={classes.markDownGrid}>
              <ReactMarkdown>{terms[i]}</ReactMarkdown>
            </Grid>
          </Grid>
        ))}
      {error && (
        <Grid item xs={12}>
          <Alert severity="error">{error}</Alert>
        </Grid>
      )}
    </Grid>
  );
};

export default SignupTermsContainer;
